(() => {
  const root = document.getElementById('cm-museum');
  if (!root) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = [...root.querySelectorAll('.cm-reveal')];

  if (reducedMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('cm-in'));
  } else {
    root.classList.add('cm-motion');
    reveals.forEach((element, index) => {
      element.style.setProperty('--cm-delay', `${Math.min((index % 6) * 70, 350)}ms`);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cm-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    reveals.forEach((element) => observer.observe(element));
  }

  // REVIEW SLIDER CONTROLS
  // Timing comes from data-review-interval="7000" in the Page markup.
  // Autoplay stops on mouse hover, keyboard focus, and hidden browser tabs.
  root.querySelectorAll('[data-review-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-review-slide]')];
    const dots = [...slider.querySelectorAll('[data-review-dot]')];
    const previous = slider.querySelector('[data-review-prev]');
    const next = slider.querySelector('[data-review-next]');
    const interval = Number.parseInt(slider.dataset.reviewInterval, 10) || 7000;
    let active = 0;
    let timer = 0;
    let hovered = false;
    let focused = false;

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      stop();
      if (reducedMotion || hovered || focused || document.hidden || slides.length < 2) return;
      timer = window.setInterval(() => show(active + 1), interval);
    };

    const show = (requested) => {
      active = (requested + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    };

    previous?.addEventListener('click', () => { show(active - 1); start(); });
    next?.addEventListener('click', () => { show(active + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));

    slider.addEventListener('mouseenter', () => { hovered = true; stop(); });
    slider.addEventListener('mouseleave', () => { hovered = false; start(); });
    slider.addEventListener('focusin', () => { focused = true; stop(); });
    slider.addEventListener('focusout', () => {
      window.setTimeout(() => {
        focused = slider.contains(document.activeElement);
        start();
      }, 0);
    });
    document.addEventListener('visibilitychange', start);
    show(0);
    start();
  });

  const banner = root.querySelector('.cm-museum-banner');
  const image = banner?.querySelector('img');
  if (reducedMotion || !banner || !image) return;

  const settings = window.getComputedStyle(banner);
  const travel = Number.parseFloat(settings.getPropertyValue('--cm-parallax-range')) || 72;
  const speed = Number.parseFloat(settings.getPropertyValue('--cm-parallax-speed')) || 0.16;
  const easing = Number.parseFloat(settings.getPropertyValue('--cm-parallax-ease')) || 0.14;

  let frame = 0;
  let bannerVisible = true;

  // PERFORMANCE: update once per browser paint and do no parallax work off-screen.
  const measure = () => {
    frame = 0;
    if (!bannerVisible || document.hidden) return;

    const bounds = banner.getBoundingClientRect();
    const distanceFromCenter = bounds.top + bounds.height / 2 - window.innerHeight / 2;
    const target = Math.max(-travel, Math.min(travel, distanceFromCenter * -speed));
    image.style.setProperty('--cm-parallax-y', `${target.toFixed(2)}px`);
  };

  const requestMeasure = () => {
    if (!frame) frame = window.requestAnimationFrame(measure);
  };

  if ('IntersectionObserver' in window) {
    const bannerObserver = new IntersectionObserver(([entry]) => {
      bannerVisible = entry.isIntersecting;
      if (bannerVisible) requestMeasure();
    }, { rootMargin: '150px 0px' });
    bannerObserver.observe(banner);
  }

  window.addEventListener('scroll', requestMeasure, { passive: true });
  window.addEventListener('resize', requestMeasure, { passive: true });
  document.addEventListener('visibilitychange', requestMeasure);
  requestMeasure();
})();
